<template lang="pug">
  #hot-links
    .container
      .row
        .col-xs-12
          titulo.-upper.-withbar Links Importantes
          ul.list
            li.item(v-for="(link, id) of links", :key="link.id")
              router-link(v-if="link.rota", :to="{ name: link.rota }") {{ link.texto }}
              a(v-else-if="link.url", :href="link.url" target="_blank" rel="noopener") {{ link.texto }}
</template>

<script>
import Titulo from 'COMPONENTS/ElementTitle'
export default {
  components: { Titulo },
  props: {
    links: { type: Array, required: true }
  }
}
</script>

<style lang="scss">
  #hot-links {
    padding: 40px 0;
    color: inherit;
    background-color: inherit;

    .title { color: inherit }

    .list {
      display: flex;
      flex-wrap: wrap;
      flex-direction: row;
      justify-content: flex-start;
      margin: 0 auto;

      > .item {
        padding: 5px 10px;

        > a {
          font-size: 16px;
          color: $color-grey-dark;
          @extend %font_medium;
          @include iconFA('before', '\f0da');
          &:before { margin-right: 7px; color: inherit; }
          &:hover { text-decoration: underline }
        }
      }
    }

    @include media(">=tablet") {
      .list { width: 90% }
      .list > .item { padding: 5px 20px; }
    }

    @include media(">=desktop") {
      .list { justify-content: flex-start }
      > .container { padding: 0 }
    }
  }
</style>



// WEBPACK FOOTER //
// HotsiteLinks.vue?0b8fc87f